var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
import { RoleCategories } from '../../common/constants/role-categories';
import { useAppDispatch } from '../../store/useStore';
import { setFileResults } from './globalSearchSlice';
export var useGlobalSearchStream = function (_a) {
    var searchText = _a.searchText, companyId = _a.companyId, currentUser = _a.currentUser;
    var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    var dispatch = useAppDispatch();
    var _b = __read(useState(false), 2), isStreaming = _b[0], setIsStreaming = _b[1];
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    useEffect(function () {
        if (!searchText || !companyId)
            return;
        var url = isSuperAdmin
            ? "".concat(API_BASE_URL, "SharePoint/in-depth-search?searchText=").concat(encodeURIComponent(searchText))
            : "".concat(API_BASE_URL, "SharePoint/in-depth-search?searchText=").concat(encodeURIComponent(searchText), "&CompanyId=").concat(companyId);
        setIsStreaming(true);
        var eventSource = new EventSource(url);
        eventSource.onmessage = function (event) {
            try {
                var parsed_1 = JSON.parse(event.data);
                dispatch(setFileResults(function (prev) { return __spreadArray(__spreadArray([], __read(prev), false), __read(parsed_1), false); }));
            }
            catch (_a) { }
        };
        eventSource.onerror = function (error) {
            console.error('EventSource error:', error);
            eventSource.close();
            setIsStreaming(false);
        };
        return function () {
            eventSource.close();
            setIsStreaming(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText, companyId, dispatch, API_BASE_URL]);
    return { isStreaming: isStreaming };
};
